import "./index.scss"

import React from "react"
import * as ReactDOMClient from "react-dom/client"
import { I18nextProvider } from "react-i18next"
import { Provider } from "react-redux"
import store from "src/redux/Store"

import QueryProvider from "./providers/QueryProvider"
import i18n from "./i18nInit"
import App from "./App"



const root = ReactDOMClient.createRoot(document.getElementById("root"))
root.render(
  React.createElement(
    QueryProvider,
    null,
    React.createElement(
      Provider,
      { store },
      React.createElement(
        I18nextProvider,
        { i18n },
        React.createElement(App)
      )
    )
  )
)
